import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import CpdTextField from '@/components/ui/CpdTextField';

const UserEmployeeInfoSection = forwardRef(
  ({ user = null, onFormChange = () => {}, disabled = false }, ref) => {
    const [employeeInfo, setEmployeeInfo] = useState({
      first_name: '',
      last_name: '',
      employee_number: '',
      management_level: '',
      approval_limit: '',
      job_code: '',
      job_title: '',
      department: '',
    });

    useEffect(() => {
      if (user?.user_data) {
        setEmployeeInfo({
          first_name: user.user_data.first_name || '',
          last_name: user.user_data.last_name || '',
          employee_number: user.user_data.employee_number || '',
          management_level: user.user_data.management_level || '',
          approval_limit: user.user_data.approval_limit || '',
          job_code: user.user_data.job_code || '',
          job_title: user.user_data.job_title || '',
          department: user.user_data.department || '',
        });
      }
    }, [user]);

    useEffect(() => {
      onFormChange(employeeInfo);
    }, [employeeInfo, onFormChange]);

    const handleChange = (field) => (event) => {
      setEmployeeInfo((prev) => ({ ...prev, [field]: event.target.value }));
    };

    useImperativeHandle(ref, () => ({
      validateForm: () => true,
      isFormValid: true,
      getFormData: () => employeeInfo,
    }));

    return (
      <Box>
        <Typography variant='h6' sx={{ mb: 3 }}>
          Employee Information
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <CpdTextField
              label='First Name'
              value={employeeInfo.first_name}
              onChange={handleChange('first_name')}
              disabled={disabled}
              sx={{ mb: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CpdTextField
              label='Last Name'
              value={employeeInfo.last_name}
              onChange={handleChange('last_name')}
              disabled={disabled}
              sx={{ mb: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CpdTextField
              label='Employee Number'
              value={employeeInfo.employee_number}
              onChange={handleChange('employee_number')}
              disabled={disabled}
              sx={{ mb: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CpdTextField
              label='Management Level'
              value={employeeInfo.management_level}
              onChange={handleChange('management_level')}
              disabled={disabled}
              sx={{ mb: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CpdTextField
              label='Approval Limit'
              value={employeeInfo.approval_limit}
              onChange={handleChange('approval_limit')}
              disabled={disabled}
              sx={{ mb: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CpdTextField
              label='Job Code'
              value={employeeInfo.job_code}
              onChange={handleChange('job_code')}
              disabled={disabled}
              sx={{ mb: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CpdTextField
              label='Job Title'
              value={employeeInfo.job_title}
              onChange={handleChange('job_title')}
              disabled={disabled}
              sx={{ mb: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CpdTextField
              label='Department'
              value={employeeInfo.department}
              onChange={handleChange('department')}
              disabled={disabled}
              sx={{ mb: 0 }}
            />
          </Grid>
        </Grid>
      </Box>
    );
  },
);

UserEmployeeInfoSection.displayName = 'UserEmployeeInfoSection';

export default UserEmployeeInfoSection;
